// src/services/api.js - Serviço de comunicação com o backend (FIXADO)
import axios from 'axios';

const API_URL =
  window.location.hostname === 'localhost'
    ? 'http://localhost:3001/api'
    : '/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor: enviar slug da empresa em toda request
api.interceptors.request.use(
  (config) => {
    console.log('📤 API Request:', (config.method || 'GET').toUpperCase(), config.url);
    try {
      const user = JSON.parse(localStorage.getItem('prospera_user') || '{}');
      if (user.slug) {
        config.headers['x-empresa-slug'] = user.slug;
      }
    } catch(e) {}
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('❌ Response Error:', error.response?.status, error.message);
    return Promise.reject(error);
  }
);

// ============================================
// OPORTUNIDADES
// ============================================
export const oportunidadesAPI = {
  listar: (filtros = {}) => api.get('/oportunidades', { params: filtros }),
  buscar: (id) => api.get(`/oportunidades/${id}`),
  criar: (dados) => api.post('/oportunidades', dados),
  atualizar: (id, dados) => api.put(`/oportunidades/${id}`, dados),
  atualizarStatus: (id, status) => api.patch(`/oportunidades/${id}/status`, { status }),
  deletar: (id) => api.delete(`/oportunidades/${id}`),
  reprovar: (id, motivo) => api.post(`/oportunidades/${id}/reprovar`, { motivo }),
  resumoPorStatus: (filtros = {}) => api.get('/oportunidades/resumo/status', { params: filtros }),
  resumoFinanceiro: (filtros = {}) => api.get('/oportunidades/resumo/financeiro', { params: filtros }),
};

// ============================================
// CUSTOS DE TERCEIROS
// ============================================
export const custosAPI = {
  listarPorOportunidade: (oportunidadeId) => api.get(`/custos/oportunidade/${oportunidadeId}`),
  adicionar: (dados) => api.post('/custos', dados),
};

// ============================================
// GESTÃO CLICK
// ============================================
export const gestaoClickAPI = {
  sincronizar: () => api.post('/gestaoclick/sync'),
  buscarClientes: (filtros = {}) => api.get('/gestaoclick/clientes', { params: filtros }),
  buscarProdutos: (filtros = {}) => api.get('/gestaoclick/produtos', { params: filtros }),
  buscarServicos: (filtros = {}) => api.get('/gestaoclick/servicos', { params: filtros }),
};

// ============================================
// RELATÓRIOS
// ============================================
export const relatoriosAPI = {
  // Top OS por Lucro
  topOSLucro: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return api.get(`/relatorios/top-os-lucro?${query}`);
  },
topOSMargemCritica: (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return api.get(`/relatorios/top-os-margem-critica?${query}`);
},

  // Dashboard original
  dashboard: () => api.get('/relatorios/dashboard'),

  // Meta vs Realizado
  metaVsRealizado: () => api.get('/relatorios/meta-vs-realizado'),

  // Dashboard Executivo (KPIs principais)
  dashboardExecutivo: (filtros = {}) => api.get('/relatorios/dashboard-executivo', { params: filtros }),

  // Gráficos
  faturamentoMensal: () => api.get('/relatorios/faturamento-mensal'),
  funilConversao: (filtros = {}) => api.get('/relatorios/funil-conversao', { params: filtros }),
  topServicos: (filtros = {}) => api.get('/relatorios/top-servicos', { params: filtros }),
  receitaCustos: (filtros = {}) => api.get('/relatorios/receita-custos', { params: filtros }),
  receitaCustos: (filtros = {}) => api.get('/relatorios/receita-custos', { params: filtros }),
  receitasOrigemCanal: (filtros = {}) => api.get('/relatorios/receitas-origem', { params: filtros }),

  // Análises
  performanceTecnicos: (filtros = {}) => api.get('/relatorios/performance-tecnicos', { params: filtros }),
  performanceExecucao: (filtros = {}) => api.get('/relatorios/performance-execucao', { params: filtros }),
  performanceVendas: (filtros = {}) => api.get('/relatorios/performance-vendas', { params: filtros }),
  performanceConsolidado: (filtros = {}) => api.get('/relatorios/performance-consolidado', { params: filtros }),
  margemPorServico: (filtros = {}) => api.get('/relatorios/margem-por-servico', { params: filtros }),
  tempoPorStatus: () => api.get('/relatorios/tempo-por-status'),
  comparativoMensal: () => api.get('/relatorios/comparativo-mensal'),
};

// ============================================
// CONFIGURAÇÕES
// ============================================
export const configuracoesAPI = {
  listar: () => api.get('/configuracoes'),
};

// ============================================
// AGENDAMENTOS
// ============================================
export const agendamentosAPI = {
  buscarPorOportunidade: (oportunidadeId) => api.get(`/agendamentos/oportunidade/${oportunidadeId}`),
  criar: (dados) => api.post('/agendamentos', dados),
  atualizar: (id, dados) => api.put(`/agendamentos/${id}`, dados),
  cancelar: (id) => api.delete(`/agendamentos/${id}`),
  listar: (filtros = {}) => api.get('/agendamentos', { params: filtros }),
};

// ============================================
// MENSAGENS AGENDADAS
// ============================================
export const mensagensAgendadasAPI = {
  criar: (dados) => api.post('/mensagens-agendadas', dados),
  listar: (filtros = {}) => api.get('/mensagens-agendadas', { params: filtros }),
  buscar: (id) => api.get(`/mensagens-agendadas/${id}`),
  cancelar: (id) => api.delete(`/mensagens-agendadas/${id}`),
  estatisticas: () => api.get('/mensagens-agendadas/estatisticas/geral'),
};

export default api;

// ============================================
// CONTA AZUL
// ============================================
export const contaAzulAPI = {
  // Auth
  status: () => api.get('/contaazul/status'),
  authorizeUrl: () => api.get('/contaazul/authorize-url'),
  callback: (code) => api.post('/contaazul/callback', { code }),
  refresh: () => api.post('/contaazul/refresh'),
  teste: () => api.get('/contaazul/teste'),
  // Pessoas
  listarPessoas: (params = {}) => api.get('/contaazul/pessoas', { params }),
  buscarPessoa: (id) => api.get(`/contaazul/pessoas/${id}`),
  criarPessoa: (dados) => api.post('/contaazul/pessoas', dados),
  // Produtos
  listarProdutos: (params = {}) => api.get('/contaazul/produtos', { params }),
  // Serviços
  listarServicos: (params = {}) => api.get('/contaazul/servicos', { params }),
  // Vendas
  listarVendas: (params = {}) => api.get('/contaazul/vendas', { params }),
  buscarVenda: (id) => api.get(`/contaazul/vendas/${id}`),
  criarVenda: (dados) => api.post('/contaazul/vendas', dados),
  // Financeiro
  listarReceitas: (params = {}) => api.get('/contaazul/receitas', { params }),
  listarDespesas: (params = {}) => api.get('/contaazul/despesas', { params }),
  // Contratos
  listarContratos: (params = {}) => api.get('/contaazul/contratos', { params }),
  // NF
  listarNotasFiscais: (params = {}) => api.get('/contaazul/notas-fiscais', { params }),
  // Sync
  syncPessoas: () => api.post('/contaazul/sync/pessoas'),
  syncLogs: () => api.get('/contaazul/sync-logs'),
  mapeamentos: (entidade) => api.get(`/contaazul/mapeamentos/${entidade}`),
};
